import React from 'react';

export default function AnimationCircle({ size = 8 }) {
  // size is in Tailwind units (e.g., 8 => h-8 w-8)
  const sizeClass = `h-${size} w-${size}`;
  return (
    <div className="w-full h-full flex items-center justify-center bg-transparent">
      <div className="relative w-full h-full flex items-center justify-center">
        <div
          className={`inline-block ${sizeClass} border-4 rounded-full animate-spin border-gray-200/70 dark:border-gray-600/70 border-t-brand-600 dark:border-t-brand-300`}
          aria-hidden="true"
        />
      </div>
    </div>
  );
}